import React from 'react';
import { MessageCircle } from 'lucide-react';
import { AIChat } from '../components/ai/AIChat';

export default function AIChatPage() {
  return (
    <div className="mb-20">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 min-h-[calc(100vh-12rem)]">
        <h2 className="text-2xl font-bold flex items-center mb-6 text-gray-900 dark:text-white">
          <MessageCircle className="w-6 h-6 mr-2 text-blue-600 dark:text-blue-400" />
          Tu Mentor Estoico
        </h2>
        
        <AIChat />
      </div>
    </div>
  );
}